(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[182],{

/***/ 10384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ generic_title_description_with_paras_GenericTitleDescriptionWithParas; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(14304);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/intro-paras/ParagraphWrapper.tsx
// hooks




var ParagraphWrapper = function(param) {
    var paragraphs = param.paragraphs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            marginTop: "1rem"
        },
        children: paragraphs.map(function(para) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "p",
                size: "sm",
                mSize: "s",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: (0,browser.sanitize)(para.content)
                    }
                }, para.id)
            });
        })
    });
};
/* harmony default export */ var intro_paras_ParagraphWrapper = (ParagraphWrapper);

// EXTERNAL MODULE: ./components/generic-title-description-with-paras/title-description-item/TitleDescriptionItem.module.scss
var TitleDescriptionItem_module = __webpack_require__(34791);
var TitleDescriptionItem_module_default = /*#__PURE__*/__webpack_require__.n(TitleDescriptionItem_module);
;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/title-description-item/TitleDescriptionItem.tsx
// types


// styles



var TitleDescriptionItem = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TitleDescriptionItem_module_default()).titleDescriptionItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "h3",
                size: "s",
                mSize: "xs",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                children: item.title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        item.title,
                        " \xa0"
                    ]
                }) : "•"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "span",
                size: "s",
                mSize: "xs",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                lineHeight: "1.5rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: (0,browser.sanitize)(item.description)
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var title_description_item_TitleDescriptionItem = (TitleDescriptionItem);

;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/title-description-item-list/TitleDescriptionItemList.tsx
// constants


var TitleDescriptionItemList = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(title_description_item_TitleDescriptionItem, {
                item: item
            }, item.id);
        })
    });
};
/* harmony default export */ var title_description_item_list_TitleDescriptionItemList = (TitleDescriptionItemList);

;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/GenericTitleDescriptionWithParas.tsx
// components




var GenericTitleDescriptionWithParas = function(param) {
    var paragraphList = param.paragraphList, titleDescriptionList = param.titleDescriptionList, heading = param.heading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "h2",
                size: "m",
                mSize: "sm",
                children: heading
            }),
            paragraphList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_paras_ParagraphWrapper, {
                paragraphs: paragraphList
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title_description_item_list_TitleDescriptionItemList, {
                items: titleDescriptionList
            })
        ]
    });
};
/* harmony default export */ var generic_title_description_with_paras_GenericTitleDescriptionWithParas = (GenericTitleDescriptionWithParas);


/***/ }),

/***/ 69298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getOnlineTruckBookingPageLayout; }
/* harmony export */ });
/* unused harmony export getOnlineTruckBookingStaticProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99891);
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62307);




var getOnlineTruckBookingPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultTopLayout */ .E;
var getOnlineTruckBookingStaticProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var faqs;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__/* .FaqService.getFaqsByCateg */ .P.getFaqsByCateg({
                        categSlug: "booking-trucks"
                    });
                case 2:
                    faqs = _ctx.sent.faqs;
                    return _ctx.abrupt("return", {
                        faqs: faqs
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOnlineTruckBookingStaticProps() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 79029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ online_truck_booking_OnlineTruckBooking; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/service-pages/online-truck-booking/OnlineTruckBooking.module.scss
var OnlineTruckBooking_module = __webpack_require__(36504);
var OnlineTruckBooking_module_default = /*#__PURE__*/__webpack_require__.n(OnlineTruckBooking_module);
// EXTERNAL MODULE: ./components/service-pages/service-data/ServiceData.ts
var ServiceData = __webpack_require__(65962);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ./components/service-pages/common/features/Features.tsx
var Features = __webpack_require__(91299);
// EXTERNAL MODULE: ./components/service-pages/common/achievements/Achievements.tsx
var Achievements = __webpack_require__(16609);
// EXTERNAL MODULE: ./components/service-pages/common/hero-section/HeroSection.tsx
var HeroSection = __webpack_require__(46523);
// EXTERNAL MODULE: ./components/service-pages/common/how-it-works/HowItWorks.tsx
var HowItWorks = __webpack_require__(42326);
// EXTERNAL MODULE: ./components/service-pages/common/faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(71729);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/service-pages/types-of-lorries/TypesOfLorries.module.scss
var TypesOfLorries_module = __webpack_require__(92049);
var TypesOfLorries_module_default = /*#__PURE__*/__webpack_require__.n(TypesOfLorries_module);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
;// CONCATENATED MODULE: ./components/service-pages/types-of-lorries/TypesOfLorries.tsx







//Icons




var TypesOfLorries = function(param) {
    var lorryTypes = param.lorryTypes, sectionTitle = param.sectionTitle, sectionText = param.sectionText;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var ref = (0,react.useState)(0), isActive = ref[0], setisActive = ref[1];
    var t = (0,esm/* useTranslation */.$G)("servicePages").t;
    var handleIsActive = function(e) {
        setisActive(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (TypesOfLorries_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((TypesOfLorries_module_default()).conainer, "container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TypesOfLorries_module_default()).heading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: sectionTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: sectionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TypesOfLorries_module_default()).lorryTypesBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TypesOfLorries_module_default()).lorryTypesNav,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: lorryTypes.map(function(data) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: isActive === data.id ? (TypesOfLorries_module_default()).active : "",
                                        onClick: function() {
                                            return handleIsActive(data.id);
                                        },
                                        children: data.type
                                    }, data.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TypesOfLorries_module_default()).lorryTypeCardWrap,
                            children: lorryTypes.map(function(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((TypesOfLorries_module_default()).lorryTypeCard, isActive === data.id ? (TypesOfLorries_module_default()).active : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TypesOfLorries_module_default()).lorryImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TypesOfLorries_module_default()).imgBox,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                    width: isMobile ? "230" : "755",
                                                    height: isMobile ? "148" : "460",
                                                    layout: "responsive",
                                                    src: data.image,
                                                    alt: data.altText
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (TypesOfLorries_module_default()).lorryText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: data.type
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: (TypesOfLorries_module_default()).count,
                                                    children: data.count
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TypesOfLorries_module_default()).label,
                                                    children: [
                                                        t("servicePages:online-truck-booking.TypesOfLorries.number-of"),
                                                        " ",
                                                        data.type,
                                                        " ",
                                                        t("servicePages:online-truck-booking.TypesOfLorries.on-Vahak")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TypesOfLorries_module_default()).topStateRow,
                                                    children: data.topStates && data.topStates.map(function(topState, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (TypesOfLorries_module_default()).stateCol,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (TypesOfLorries_module_default()).stateCard,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                                        sizes: "(min-width: 992px) 170px, 100px",
                                                                        width: isMobile ? "100" : "170",
                                                                        height: isMobile ? "79" : "134",
                                                                        src: topState.image,
                                                                        alt: topState.state
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: topState.state
                                                                    })
                                                                ]
                                                            })
                                                        }, index);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TypesOfLorries_module_default()).label,
                                                    children: [
                                                        t("servicePages:online-load-booking.TypesOfLoads.top-locations-for"),
                                                        " ",
                                                        data.type
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TypesOfLorries_module_default()).bookBtnWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: data.btnURL,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            target: "_blank",
                                                            onClick: function() {
                                                                (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_truck_booking */.wQ.Servicepage_online_truck_booking, {
                                                                    value: event_names/* GA4ServicePageOnlineTruckBookingEventValues.book_lorries */.n9.book_lorries
                                                                });
                                                            },
                                                            children: [
                                                                t("servicePages:online-truck-booking.TypesOfLorries.book"),
                                                                " ",
                                                                data.type,
                                                                " ",
                                                                t("servicePages:online-truck-booking.TypesOfLorries.now"),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {})
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, data.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var types_of_lorries_TypesOfLorries = (TypesOfLorries);

// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ./constants/breadcrumbs-constants.ts
var breadcrumbs_constants = __webpack_require__(96080);
// EXTERNAL MODULE: ./components/service-pages/common/service-information/ServiceInformation.tsx
var ServiceInformation = __webpack_require__(35778);
// EXTERNAL MODULE: ./components/generic-title-description-with-paras/GenericTitleDescriptionWithParas.tsx + 3 modules
var GenericTitleDescriptionWithParas = __webpack_require__(10384);
;// CONCATENATED MODULE: ./components/service-pages/online-truck-booking/OnlineTruckBooking.tsx




















var metaData = {
    title: "Online Truck Booking in India, Truck Rental Services | Vahak",
    description: "Find the right truck for your business through India's largest online truck booking community. Hire trucks, containers, and more with 0% commission.",
    keywords: "truck booking,truck transport, lorry transport, online truck booking, truck rental, truck booking app, lorry transport services, truck transportation services, lorry service near me, online mini truck booking, truck rental near me, mini truck booking, truck rental services, book a lorry, lorry booking,mini truck transport near me, online truck booking app, hire truck online, truck booking price, trucks portal online, online goods vehicle booking, book a truck for shifting, truck booking india, truck for hire near me, book transport truck, app for truck booking, online truck booking system, online truck service,",
    canonicalUrl: "https://www.vahak.in/online-truck-booking",
    schemaOrgJsonUrl: "/online-truck-booking",
    ogImgSrc: "https://d3ib4ot6oar1ep.cloudfront.net/1080/75/webp/online-truck-booking-app_desktop.png",
    ogImgAltText: "Online Truck Booking",
    breadcrumbList: (0,breadcrumbs_constants/* breadcrumbsConstants */.U)({}).onlineLorryBooking
};
var OnlineTruckBooking = function(param) {
    var faqs = param.faqs;
    var t = (0,esm/* useTranslation */.$G)("servicePages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: metaData.title,
                description: metaData.description,
                keywords: metaData.keywords,
                canonicalUrl: metaData.canonicalUrl,
                ogUrl: metaData.canonicalUrl,
                ogImgSrc: metaData.ogImgSrc,
                ogImgAltText: metaData.ogImgAltText,
                schemaOrgJsonUrl: metaData.schemaOrgJsonUrl,
                breadcrumbList: metaData.breadcrumbList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (OnlineTruckBooking_module_default()).main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
                        bannerTitle: t("servicePages:online-truck-booking.hero-section.title"),
                        bannerText: t("servicePages:online-truck-booking.hero-section.bannerText"),
                        hrefLabel: t("servicePages:online-truck-booking.hero-section.hrefLabel"),
                        hrefURL: "".concat(routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("lorry"), "?").concat(misc/* SOURCE_UTM */.vq, "=").concat(Pages/* PageTypes.ONLINE_TRUCK_BOOKING */.c.ONLINE_TRUCK_BOOKING),
                        onLinkClick: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_truck_booking */.wQ.Servicepage_online_truck_booking, {
                                value: event_names/* GA4ServicePageOnlineTruckBookingEventValues.book_trucks_now */.n9.book_trucks_now
                            });
                        },
                        // srcSetURL={`${IMG_BASE_URL}/online-truck-booking-app_desktop_3x.png 1587w, ${IMG_BASE_URL}/online-truck-booking-app_desktop_2x.png 1058w, ${IMG_BASE_URL}/online-truck-booking-app_desktop.png 529w, ${IMG_BASE_URL}/online-truck-booking-app_mobile_3x.png 828w, ${IMG_BASE_URL}/online-truck-booking-app_mobile_2x.png 552w, ${IMG_BASE_URL}/online-truck-booking-app_mobile.png 276w`}
                        srcURL: "online-truck-booking-app_desktop.png",
                        altText: "vahak online truck booking app with lorries"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Achievements/* default */.Z, {
                        achievementData: (0,ServiceData/* useOtbAchievement */.KY)(),
                        sectionTitle: t("servicePages:online-truck-booking.achievements.sectionTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceInformation/* default */.Z, {
                        heading: t("servicePages:online-truck-booking.features-of-vahak-truck-booking-service.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:online-truck-booking.features-of-vahak-truck-booking-service.description"),
                        descriptionComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericTitleDescriptionWithParas/* default */.Z, {
                                titleDescriptionList: (0,ServiceData/* useOtbServiceFeature */.qm)(),
                                heading: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* default */.Z, {
                        features: (0,ServiceData/* useOtbFeatures */.ri)(),
                        sectionTitle: t("servicePages:online-truck-booking.features.sectionTitle"),
                        ctaLink: "".concat(routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("lorry")),
                        ctaLabel: t("servicePages:online-truck-booking.features.ctaLabel"),
                        onCtaClick: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_truck_booking */.wQ.Servicepage_online_truck_booking, {
                                value: event_names/* GA4ServicePageOnlineTruckBookingEventValues.start_booking_now */.n9.start_booking_now
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
                        howitwork: (0,ServiceData/* useOtbHowItworkData */.FY)(),
                        sectionTitle: t("servicePages:online-truck-booking.HowItWorks.sectionTitle"),
                        sectionText: t("servicePages:online-truck-booking.HowItWorks.sectionText"),
                        tabAppNav: t("servicePages:online-load-booking.HowItWorks.tabAppNav"),
                        tabWebNav: t("servicePages:online-load-booking.HowItWorks.tabWebNav"),
                        onAppTabChange: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_truck_booking */.wQ.Servicepage_online_truck_booking, {
                                value: event_names/* GA4ServicePageOnlineTruckBookingEventValues.mobile_app */.n9.mobile_app
                            });
                        },
                        onWebTabChange: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_truck_booking */.wQ.Servicepage_online_truck_booking, {
                                value: event_names/* GA4ServicePageOnlineTruckBookingEventValues.web */.n9.web
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(types_of_lorries_TypesOfLorries, {
                        lorryTypes: (0,ServiceData/* useLorryTypesData */.cn)(),
                        sectionTitle: t("servicePages:online-truck-booking.TypesOfLorries.sectionTitle"),
                        sectionText: t("servicePages:online-truck-booking.TypesOfLorries.sectionText")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                        faqs: faqs,
                        sectionTitle: t("servicePages:online-load-booking.Faq.sectionTitle"),
                        sectionText: t("servicePages:online-load-booking.Faq.sectionText")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var online_truck_booking_OnlineTruckBooking = (OnlineTruckBooking);


/***/ }),

/***/ 34791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleDescriptionItem":"TitleDescriptionItem_titleDescriptionItem__LU6aL"};

/***/ }),

/***/ 36504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"OnlineTruckBooking_main__MLfB_"};

/***/ }),

/***/ 92049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"TypesOfLorries_main__hgPS3","heading":"TypesOfLorries_heading__kCU0A","lorryTypeCardWrap":"TypesOfLorries_lorryTypeCardWrap__C_nZg","lorryTypesNav":"TypesOfLorries_lorryTypesNav__DLk7m","lorryTypeCard":"TypesOfLorries_lorryTypeCard__c5fu6","lorryText":"TypesOfLorries_lorryText__cDPwX","bookBtnWrapper":"TypesOfLorries_bookBtnWrapper__gkEb_","imgBox":"TypesOfLorries_imgBox__2OTaT","topStateRow":"TypesOfLorries_topStateRow__5HdJd","count":"TypesOfLorries_count__fDeW1","label":"TypesOfLorries_label__jb1P4","active":"TypesOfLorries_active__PPr8k","lorryImage":"TypesOfLorries_lorryImage__vzAX6","fadeInActive":"TypesOfLorries_fadeInActive__IiNGb","stateCol":"TypesOfLorries_stateCol__ZYbKI","stateCard":"TypesOfLorries_stateCard___MRxd"};

/***/ })

}]);